/**
 * Market Domination Solutions Brand Colors
 *
 * Usage: import { colors, gradients } from './brand-colors';
 */

export const colors = {
  // Greys (light to dark)
  greyLightest: '#ebebeb',
  greyLight: '#bfbfbf',
  greyMid: '#7f7f7f',
  grey: '#525252',
  greyDark: '#3e3e3e',
  greyDarker: '#181818',
  greyDarkest: '#0a0a0a',  // Nav bar background

  // Reds (dark to light)
  redDarkest: '#8b0108',
  redDark: '#a10000',      // Button gradient start
  red: '#ba1d1d',
  redLight: '#db3838',
  redLightest: '#de4a4a',

  // Golds (dark to light)
  goldDark: '#816532',
  gold: '#ba934f',
  goldMid: '#cca557',
  goldLight: '#ddb75e',    // Nav bar text, accents

  // Navys (for informational/secondary elements)
  navyDark: '#1B2A4A',
  navy: '#1E3A5F',
  navyLight: '#2A4A73',

  // Teals/Cyans (for dashboard charts)
  tealDark: '#0891B2',
  teal: '#06B6D4',
  tealMid: '#22D3EE',
  tealLight: '#67E8F9',
};

export const gradients = {
  // Red button gradient (left to right)
  redButton: 'linear-gradient(90deg, #D03737 0%, #A30202 100%)',
  redButtonHover: 'linear-gradient(90deg, #db4a4a 0%, #ba1d1d 100%)',
  // Disabled button gradient
  disabledButton: 'linear-gradient(90deg, #bfbfbf 0%, #7f7f7f 100%)',
  // Navy info gradient (left to right)
  navyButton: 'linear-gradient(90deg, #1E3A5F 0%, #1B2A4A 100%)',
  navyButtonHover: 'linear-gradient(90deg, #2A4A73 0%, #1E3A5F 100%)',
  // Aliases used by BattlePlan month badges
  primary: 'linear-gradient(90deg, #D03737 0%, #A30202 100%)',    // same as redButton
  success: 'linear-gradient(90deg, #ddb75e 0%, #816532 100%)',    // gold gradient
};

// For quick reference in CSS
export const cssVars = `
  --brand-grey-lightest: #ebebeb;
  --brand-grey-light: #bfbfbf;
  --brand-grey-mid: #7f7f7f;
  --brand-grey: #525252;
  --brand-grey-dark: #3e3e3e;
  --brand-grey-darker: #181818;
  --brand-grey-darkest: #0a0a0a;
  --brand-red-darkest: #8b0108;
  --brand-red-dark: #a10000;
  --brand-red: #ba1d1d;
  --brand-red-light: #db3838;
  --brand-red-lightest: #de4a4a;
  --brand-gold-dark: #816532;
  --brand-gold: #ba934f;
  --brand-gold-mid: #cca557;
  --brand-gold-light: #ddb75e;
  --brand-navy-dark: #1B2A4A;
  --brand-navy: #1E3A5F;
  --brand-navy-light: #2A4A73;
`;

export default colors;
